import React from 'react';
import { Container } from 'react-bootstrap';
import Reveal from './Reveal';

const projects = [
  {
    image: `${process.env.PUBLIC_URL}/pool_room.jpg`,
    tag: 'Domestic',
    title: 'Feature lighting',
    description:
      'A clean domestic finish in a vaulted living and games room.',
    alt: 'Feature lighting inside a vaulted living and games room',
  },
  {
    image: `${process.env.PUBLIC_URL}/lotus.jpg`,
    tag: 'Specialist interior',
    title: 'Specialist interiors',
    description:
      'Electrical work where presentation and detail both matter.',
    alt: 'A specialist showroom and display environment used in Moonwood Electrical project photography',
  },
  {
    image: `${process.env.PUBLIC_URL}/3_phase.jpg`,
    tag: 'Industrial',
    title: 'Industrial spaces',
    description:
      'Lighting and electrical infrastructure for larger working environments.',
    alt: 'Lighting and electrical work underway in a large industrial building',
  },
];

const PictureGallerySection = () => {
  return (
    <section className="content-section content-section--alt" id="work">
      <Container>
        <Reveal className="section-heading">
          <p className="section-eyebrow">Recent work</p>
          <h2>A small selection of recent work.</h2>
          <p className="section-heading__intro">
            Examples from domestic, specialist and industrial settings.
          </p>
        </Reveal>

        <div className="project-grid">
          {projects.map(({ image, tag, title, description, alt }, index) => (
            <Reveal
              as="figure"
              className="project-card"
              delay={index * 90}
              key={title}
            >
              <div className="project-card__media">
                <img
                  src={image}
                  alt={alt}
                  width="1200"
                  height="900"
                  loading="lazy"
                  decoding="async"
                />
              </div>
              <figcaption className="project-card__body">
                <p className="project-card__tag">{tag}</p>
                <h3>{title}</h3>
                <p>{description}</p>
              </figcaption>
            </Reveal>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default PictureGallerySection;
